// TODO Move level above
export default function Task($resource, ENV) {
  'ngInject';

  return $resource(
    `${ENV.apiUrl}/pingsta/tasks/:taskId.json`,
    { taskId: '@id' },
    {
      'query': {
        method: 'GET',
        isArray: false,
      },

      'getActions': {
        method: 'GET',
        url: `${ENV.apiUrl}/pingsta/tasks/:taskId/actions.json`,
        isArray: false,
      },

      'accept': {
        method: 'POST',
        url: `${ENV.apiUrl}/pingsta/tasks/:taskId/accept.json`,
        params: {
          taskId: '@id'
        }
      },

      'requeue': {
        method: 'POST',
        url: `${ENV.apiUrl}/pingsta/tasks/:taskId/requeue.json`,
        params: {
          taskId: '@id'
        }
      },

      'requestHardware': {
        method: 'POST',
        url: `${ENV.apiUrl}/pingsta/tasks/:taskId/request_hardware.json`,
        params: {
          taskId: '@id'
        }
      },

      'requestSoftware': {
        method: 'POST',
        url: `${ENV.apiUrl}/pingsta/tasks/:taskId/request_software.json`,
        params: {
          taskId: '@id'
        }
      },

      'requestClosure': {
        method: 'POST',
        url: `${ENV.apiUrl}/pingsta/tasks/:taskId/request_closure.json`,
        params: {
          taskId: '@id'
        }
      },
    }
  );
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/tasks/util/task.factory.js